import {http} from "@/helpers/http-helper";

export const deleteCampaign = (campaignId) => {
  return new Promise( (resolve, reject) => {
    const url = 'campaign/' + campaignId;
    http.delete(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCampaigns = (params = {}) => {
  return new Promise((resolve, reject) => {
    const queryString = Object.keys(params)
      .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');

    const fullUrl = queryString ? `campaigns?${queryString}` : 'campaigns';
    http.get(fullUrl)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCampaignById = (campaignId, config = {}) => {
  return new Promise((resolve, reject) => {
    const url = 'campaign/' + campaignId;
    http.get(url, config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSearchCampaigns = (params = {}) => {
  return new Promise((resolve, reject) => {
    const url = 'campaigns/search';

    const queryString = Object.keys(params)
      .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');

    const fullUrl = queryString ? `${url}?${queryString}` : url;

    http.get(fullUrl)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteCampaignAttachment = (campaignId, attachmentId) => {
  return new Promise((resolve, reject) => {
    const url = 'campaigns/' + campaignId + '/attachments/' + attachmentId;
    http.delete(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCampaign = (campaignId) => {
  return new Promise((resolve, reject) => {
    const url = 'campaign/' + campaignId;
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const duplicateCampaign = (campaignId) => {
  return new Promise((resolve, reject) => {
    const url = 'campaign/' + campaignId + '/duplicate';
    http.post(url)
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};